export default "__VITE_ASSET__GBEofYPR__"